import styled from "styled-components"
import {useSelector} from 'react-redux';
import axios from "axios"
import {baseURL} from "../../services/authentication.js"
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import {useState} from "react"



const Container=styled.div`
	border: 1px solid #f91318;
	margin:25px 0px 0px 0px;
	border-radius: 8px;
	height:150px;
	color:#ea0006;
	display:flex;
	flex-direction:column;
	justify-content:space-between;
	align-items:center;
	overflow:hidden
`;

const DeleteButton=styled.button`

`;

let TituloDnager=styled.div`
	width:100%;
	display:flex;
	justify-content:center;
	background-color:#efa0a3
`;


export default function DeleteVideo(){
	const data=useSelector(state=>state.data);
	let [send,setSend]=useState(false)

	const idsAndNames=[];

	if(data.length>0){data.forEach(ele=>{for (const nameGroup in ele) { ele[nameGroup].map(item=>idsAndNames.push({ id:item.ID, name:item.name }))  } })} 
	
	const ButtonDisable=(id,val)=>{document.getElementById(id).disabled=val };

	const handleChange=(e)=>{
		let target=e.target;

		target.value===''?ButtonDisable("delete",true):ButtonDisable("delete",false)

	};

	

	const eliminar=async(e)=>{
		e.preventDefault();
		//let token=getToken();
		let option=document.getElementById("ids");
		if(option.value!==""){

			if(window.confirm(`deseas eliminar el tutorial ?`)){
				try{
					 let rpta = await axios.delete(`${baseURL}/farmasistutorials/delete/${option.value}`
					 	//,{headers: {Authorization:`Bearer ${token}`} }
					 	);
					 alert(rpta.data);
					 
				}catch(err){alert( 'error detectado :'+err.message)}
			}
		}
					
	}


	



	return(
	<Container>
		<TituloDnager>DANGER ZONE</TituloDnager>
		<div>Delete tutorial</div>
		<select onChange={handleChange} id="ids" disabled={send}>
			<option value="" disabled selected>selecionar video</option>
			{idsAndNames.map(ele=><option key={ele.id} value={ele.id} name={ele.name} >{ele.name}</option> )}
		</select>
		<Button  id="delete" variant="contained" sx={{marginBottom:"10px"}} loadingPosition="start" startIcon={<DeleteIcon />} loading={send}  onClick={eliminar}>borrar</Button>	
	</Container>
	)
}